/**
 * Remote bayiye geçiş / remote'tan çıkış sayfayı `window.location.reload()` ile yeniler.
 * Duyuru popup'ı normalde yalnız login sonrası `navigate` (dolu `location.state`) ile ve
 * reload olmayan gezintide istenir; bu tek kullanımlık işaret reload'dan sonra popup'ın
 * bir kez istenmesini sağlar. sessionStorage erişilemezse sessizce yok sayılır.
 */
const POPUP_AFTER_REMOTE_KEY = 'INDEXPAZAR_POPUP_AFTER_REMOTE'

type FlagStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

const sessionStore = (): FlagStorage | undefined => {
  try {
    return window.sessionStorage
  } catch {
    return undefined
  }
}

export function markPopupAfterRemote(storage: FlagStorage | undefined = sessionStore()): void {
  try {
    storage?.setItem(POPUP_AFTER_REMOTE_KEY, '1')
  } catch {
    // sessionStorage kapalıysa popup yalnız login akışında açılır
  }
}

/** İşaret varsa true döner ve işareti siler (tek kullanımlık). */
export function consumePopupAfterRemote(storage: FlagStorage | undefined = sessionStore()): boolean {
  try {
    if (storage?.getItem(POPUP_AFTER_REMOTE_KEY) !== '1') return false
    storage.removeItem(POPUP_AFTER_REMOTE_KEY)
    return true
  } catch {
    return false
  }
}
